import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path d="M8.39 3.506a.536.536 0 0 1 1.07-.015l.438 5.261a.27.27 0 0 0 .539-.003l.446-6.25a.535.535 0 0 1 .906-.35.524.524 0 0 1 .165.35l.447 6.25a.269.269 0 0 0 .348.24.27.27 0 0 0 .19-.237l.439-5.26a.536.536 0 0 1 1.069.014l.386 6.95a3 3 0 0 1-1.121 2.51c-.79.631-.793.98-.793 1.995V28.5a1.5 1.5 0 1 1-3 0V14.961c0-1.015-.004-1.364-.793-1.995a3 3 0 0 1-1.121-2.51l.386-6.95z"></path><path d="M21.919 14.838c.003-.57.032-1.142.368-1.334 1.542-.881 2.438-2.651 2.261-4.42C24.241 6.015 23.632 2 20.419 2c-3.213 0-3.822 4.015-4.13 7.085-.176 1.768.72 3.538 2.262 4.419.368.21.368.878.368 1.496v13.5a1.5 1.5 0 0 0 3 0V14.838z"></path></g>';
export var UtensilsSVG = function UtensilsSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
UtensilsSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(UtensilsSVG);